import React from 'react';
import { Server, Briefcase, CheckCircle } from 'lucide-react';
import './ServicesSection.css';

const services = [
  {
    icon: Server,
    title: 'Backend Development',
    description:
      'Building robust, scalable backend systems and RESTful APIs with Django, FastAPI, and Laravel. Focus on performance, security, and clean architecture.',
    badge: null,
    tags: ['Django', 'FastAPI', 'Laravel', 'PostgreSQL', 'MongoDB', 'Docker', 'Redis'],
    color: 'emerald',
  },
  {
    icon: Briefcase,
    title: 'Freelance Project Development',
    description:
      'Full-cycle development from concept to deployment. Custom web apps, MVPs, API integration, and ongoing maintenance.',
    badge: '100% On-Time Delivery',
    tags: ['E-commerce', 'Social Platforms', 'Delivery Systems', 'CRM Solutions', 'Dashboards'],
    color: 'purple',
  },
];

const ServicesSection = ({ isVisible }) => {
  return (
    <section id="services" className="services-section">
      <div className="services-bg-effects">
        <div className="services-bg-glow services-bg-glow-1" />
        <div className="services-bg-glow services-bg-glow-2" />
      </div>

      <div className="services-container">
        <div className={`services-header ${isVisible ? 'animate-slide-up' : 'opacity-0'}`}>
          <p className="services-label">What I Offer</p>
          <h2 className="services-title">
            My <span className="gradient-text">Services</span>
          </h2>
          <p className="services-subtitle">Expertise You Can Rely On</p>
        </div>

        <div className="services-grid">
          {services.map((service, index) => {
            const Icon = service.icon;
            return (
              <div
                key={index}
                className={`service-card service-card--${service.color} ${
                  isVisible ? 'animate-scale-in' : 'opacity-0'
                }`}
                style={{ animationDelay: `${index * 0.15}s` }}
              >
                <div className="service-card-top">
                  <div className={`service-icon-wrapper service-icon-wrapper--${service.color}`}>
                    <Icon className="service-icon" />
                  </div>
                  {service.badge && (
                    <div className="service-badge">
                      <CheckCircle size={12} />
                      {service.badge}
                    </div>
                  )}
                </div>

                <h3 className="service-title">{service.title}</h3>
                <p className="service-description">{service.description}</p>

                <div className="service-tags">
                  {service.tags.map((tag, i) => (
                    <span key={i} className={`service-tag service-tag--${service.color}`}>
                      {tag}
                    </span>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
